/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

export interface IUserContext {
  openUserCard: boolean;
  setOpenUserCard: (value: boolean) => void;
  openEditUserCard: boolean;
  setOpenEditUserCard: (value: boolean) => void;
}

export const UserContext = createContext<IUserContext>({
  openUserCard: false,
  setOpenUserCard: () => {},
  openEditUserCard: false,
  setOpenEditUserCard: () => {},
});
